import * as http from './http'

import { PaymentPageModel } from '@ViewModels/PaymentPageModel'
import { PaymentDto } from '@ViewModels/PaymentDto'
import { PaymentDeferRequest } from '@ViewModels/PaymentDeferRequest'

const paymentApi = '/api/store/payment'

export const getModelData = async (): Promise<PaymentPageModel> => {
   const url = `${paymentApi}`
   return http.get(url)
}

export const makePayment = async (data: PaymentDto): Promise<CommitResult> => {
   const url = `${paymentApi}`
   const result = (await http.post(url, data)) as CommitResult
   return result
}

export const emailReceipt = async (
   paymentId: string,
   emailAddress: string,
   creditCardNumber: string,
   creditCardNameOnCard: string
): Promise<CommitResult> => {
   const url = `${paymentApi}/receipt`
   return (await http.post(url, {
      paymentId,
      emailAddress,
      creditCardNameOnCard,
      creditCardNumber,
   })) as CommitResult
}

export const emailDefer = async (data: PaymentDeferRequest): Promise<any> => {
   const url = `${paymentApi}/defer`
   return await http.post(url, data)
}
